import * as React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { Button, Grid } from 'react-bootstrap';
import { connect } from 'react-redux';

import { acceptCookiePolicy, rejectCookiePolicy } from '../../application/actions';

const mapStateToProps = ({ application: { cookiePolicyState } }) => ({ cookiePolicyState });
const mapDispatchToProps = { acceptCookiePolicy, rejectCookiePolicy };

@Radium
@connect(mapStateToProps, mapDispatchToProps)
export default class CookiesPolicy extends React.Component {
  static propTypes = {
    acceptCookiePolicy: PropTypes.func.isRequired,
    cookiePolicyState: PropTypes.string,
    rejectCookiePolicy: PropTypes.func.isRequired
  }

  static defaultProps = {
    cookiePolicyState: null
  }

  renderAcceptButton() {
    const { acceptCookiePolicy } = this.props;

    return <Button bsStyle="primary" bsSize="xs" style={styles.button} onClick={acceptCookiePolicy}>Souhlasím se zpracováním volitelných cookies</Button>;
  }

  renderRejectButton() {
    const { rejectCookiePolicy } = this.props;

    return <Button bsStyle="danger" bsSize="xs" style={styles.button} onClick={rejectCookiePolicy}>Odmítám zpracování volitelných cookies</Button>;
  }

  renderAcceptedPolicy() {
    return [
      <strong> odsouhlaseno </strong>,
      this.renderRejectButton()
    ];
  }

  renderRejectedPolicy() {
    return [
      <strong> odmítnuto </strong>,
      this.renderAcceptButton()
    ];
  }

  renderUnknownPolicy() {
    return [
      <strong> neurčeno </strong>,
      this.renderAcceptButton(),
      this.renderRejectButton()
    ];
  }

  render() {
    const { cookiePolicyState } = this.props;

    return (<Grid>
      <Helmet>
        <title>Zásady soukromí</title>
      </Helmet>
      <h1 style={styles.h1}>Zásady zpracování souborů cookies</h1>

      Udělením souhlasu se zpracováním souborů cookies udělujete souhlas se zpracováním cookies provozovatelem webu Stužák, z.s. za účelem analýzy návštěvnosti.

      <h3>Zpracovávané soubory cookies - nutné</h3>
      <ul>
        <li><strong>cookiePolicyState</strong> - slouží k zapamatování Vaší volby ohledně zpracování volitelných údajů cookies.</li>
      </ul>

      <h3>Zpracovávané soubory cookies - volitelné</h3>
      <ul>
        <li><strong>_ga, _gat, _gid</strong> - cookies zpracovávané za účelem analýzy návštěvnosti webových stránek.</li>
      </ul>

      <h3>Nastavení souborů cookies</h3>
      Současný stav:
      { cookiePolicyState === 'accepted' && this.renderAcceptedPolicy() }
      { cookiePolicyState === 'rejected' && this.renderRejectedPolicy() }
      { !cookiePolicyState && this.renderUnknownPolicy() }

      <p>&nbsp;</p>

      <p>Tyto podmínky jsou platné od 24.5.2018.</p>

      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </Grid>);
  }
}

const styles = {
  h1: {
    textAlign: 'center'
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/CookiesPolicy/index.jsx